<template>
    <va-create-layout>
        <GuaranteeClaimEvent-form
            :title="title"
            :item="item"
        ></GuaranteeClaimEvent-form>
    </va-create-layout>
</template>

<script>
export default {
    props: ["title", "item"],
};
</script>
